import '../../httpservices/core/ajax.httpservice.core';

class DownloadMyRecordHttpService
{
    IndexGetPageDataInit() {
        return $.get('Patient/AppointmentSummary/IndexGetPageDataInit');
    }

    ViewMyRecordsLog() {
        return $.get('Patient/AppointmentSummary/MyRecordsLogData');
    }

    SaveForm(model) {
        return $.post('Patient/AppointmentSummary/SendCCDADocument', model);
    }
}

export const DownloadMyRecordHttpSvc = new DownloadMyRecordHttpService();